var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor custom-webhook" },
    [
      _c(
        "div",
        { staticClass: "editor-row" },
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("URL")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Enter URL",
              "show-attributes": true,
              "show-emoji": false,
            },
            model: {
              value: _vm.clone.url,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "url", $$v)
              },
              expression: "clone.url",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row" },
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("Method")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              model: {
                value: _vm.clone.method,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "method", $$v)
                },
                expression: "clone.method",
              },
            },
            _vm._l(_vm.httpMethods, function (method) {
              return _c(
                "a-select-option",
                { key: method, attrs: { value: method } },
                [_vm._v(_vm._s(method))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row" },
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("Headers")]),
          _vm._v(" "),
          _vm._l(_vm.clone.headers, function (header, index) {
            return _c(
              "div",
              { key: "header-" + index, staticClass: "key-value-pair" },
              [
                _c("a-input", {
                  staticClass: "key-input",
                  attrs: { placeholder: "Header Key" },
                  model: {
                    value: header.key,
                    callback: function ($$v) {
                      _vm.$set(header, "key", $$v)
                    },
                    expression: "header.key",
                  },
                }),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Header Value",
                    "show-attributes": true,
                    "show-emoji": false,
                  },
                  model: {
                    value: header.value,
                    callback: function ($$v) {
                      _vm.$set(header, "value", $$v)
                    },
                    expression: "header.value",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link", danger: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeHeader(index)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "add-btn",
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addHeader },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(" Add Header\n        "),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showBodySection
        ? [
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Body Type"),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    model: {
                      value: _vm.clone.bodyFormat,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "bodyFormat", $$v)
                      },
                      expression: "clone.bodyFormat",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "json" } }, [
                      _vm._v("JSON"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "formData" } }, [
                      _vm._v("Form Data"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "urlencoded" } }, [
                      _vm._v("URL Encoded"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "raw" } }, [
                      _vm._v("Raw"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "raw-json" } }, [
                      _vm._v("Raw JSON"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Body"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.clone.body, function (bodyItem, index) {
                  return _vm.clone.bodyFormat !== "raw-json"
                    ? _c(
                        "div",
                        { key: "body-" + index, staticClass: "key-value-pair" },
                        [
                          _c("a-input", {
                            staticClass: "key-input",
                            attrs: { placeholder: "Body Key" },
                            model: {
                              value: bodyItem.key,
                              callback: function ($$v) {
                                _vm.$set(bodyItem, "key", $$v)
                              },
                              expression: "bodyItem.key",
                            },
                          }),
                          _vm._v(" "),
                          _c("TiptapEditor", {
                            attrs: {
                              placeholder: "Body Value",
                              "show-attributes": true,
                              "show-emoji": false,
                            },
                            model: {
                              value: bodyItem.value,
                              callback: function ($$v) {
                                _vm.$set(bodyItem, "value", $$v)
                              },
                              expression: "bodyItem.value",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", danger: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeBody(index)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.clone.bodyFormat !== "raw-json"
                  ? _c(
                      "a-button",
                      {
                        staticClass: "add-btn",
                        attrs: { type: "dashed", block: "" },
                        on: { click: _vm.addBody },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(" Add Body Parameter\n            "),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.clone.bodyFormat === "raw-json"
                  ? _c("TiptapEditor", {
                      attrs: {
                        placeholder: "Paste JSON here",
                        "show-attributes": true,
                        "show-emoji": false,
                      },
                      model: {
                        value: _vm.clone.rawJson,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "rawJson", $$v)
                        },
                        expression: "clone.rawJson",
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Example Response"),
          ]),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "" },
              on: {
                click: function ($event) {
                  _vm.showResponseModal = true
                },
              },
            },
            [_vm._v("SET RESPONSE")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showResponseModal
        ? _c("Modal2", {
            attrs: { title: "Set Example Response" },
            on: { cancel: _vm.handleCancel, ok: _vm.saveResponse },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c("a-textarea", {
                        attrs: {
                          placeholder: "Paste JSON/Response here",
                          rows: "10",
                        },
                        model: {
                          value: _vm.responseInput,
                          callback: function ($$v) {
                            _vm.responseInput = $$v
                          },
                          expression: "responseInput",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              842839968
            ),
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }